import React from 'react';
export function IntroContent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3220">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3221">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border mb-12" style={{
        borderColor: '#ede9e0'
      }} data-id="element-3222">
          <p className="text-lg font-medium text-gray-900 mb-6 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3223">
            In today's world, being prepared can not be underestimated. What
            would you be able to do in the event of an attack by an individual
            if you didn't have any form of protection? The FLSC Self Defense
            Class series is where you find out.
          </p>
          <p className="text-base text-gray-800 mb-4 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3224">
            Your instructors are 20 year veteran of the Fenton Police
            Department, Detective Tom Cole and his wife Amy. Detective Cole
            spent several years as the Student Resource Officer for Fenton
            Public Schools. He and his wife have shared this training for
            several years and we are excited to have them do so at Fenton Lakes
            Sportsman's Club.
          </p>
          <p className="text-base text-gray-800 mb-4 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3225">
            The course is built around 3 levels of classes building on each
            previous level. You will cover becoming prepared and aware of your
            surroundings and the potential threats that lie within them over the
            three courses. Level one for example teaches the skills to get out
            of holds such as wrist holds, bear hugs and head locks. Additionally
            there will be instruction on striking and blocking.
          </p>
          <p className="text-base text-gray-800 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3226">
            The curriculum is oriented toward women ages 10 and up but everyone
            is welcome to attend and learn. This class is open to the FLSC
            members and the general public on August 20th from 6 - 9 PM.
          </p>
        </div>
      </div>
    </div>;
}